import { combineReducers } from 'redux';
import * as types from 'legacy/src/constants/types';

const rendering = (state = true, action) => {
  switch (action.type) {
    case types.WIZARDS_INFO_FETCH:
      return true;
    case types.WIZARDS_INFO_FULLFILLED:
      return false;
    case types.WIZARDS_DISABLE:
      return false;
    default:
      return state;
  }
};

const video = (state = null, action) => {
  switch (action.type) {
    case types.WIZARDS_INFO_FULLFILLED:
      if (action.wizardType === 'video') {
        return action.video;
      }
      return state;
    default:
      return state;
  }
};

const showWizard = (state = null, action) => {
  switch (action.type) {
    case types.WIZARDS_INFO_FULLFILLED:
      if (action.wizardType === 'examResponse' && action.url) {
        return true;
      }
      return state;
    case types.WIZARDS_DISABLE:
    case types.WIZARDS_EXAM_CLOSE:
    case types.WIZARDS_EXAM_CLOSE_READY:
      return false;
    default:
      return state;
  }
};

const showWizardButtons = (state = false, action) => {
  switch (action.type) {
    case types.WIZARDS_DISABLE:
      return false;
    default:
      return state;
  }
};

const showWizardReminders = (state = true, action) => {
  switch (action.type) {
    case types.WIZARDS_DISABLE:
      return false;
    default:
      return state;
  }
};

const url = (state = '', action) => {
  switch (action.type) {
    case types.WIZARDS_EXAM_CLOSE_READY:
      return '';
    case types.WIZARDS_INFO_FULLFILLED:
      if (action.url && action.wizardType === 'examResponse') {
        return action.url;
      }
      return state;
    default:
      return state;
  }
};

const subjects = (state = null, action) => {
  switch (action.type) {
    case types.WIZARDS_INFO_FULLFILLED:
      if (action.wizardType === 'examResponse') {
        return action.subjects;
      }
      return state;
    default:
      return state;
  }
};

const examResponsesWindowOpen = (state = null, action) => {
  switch (action.type) {
    case types.WIZARDS_DISABLE:
      return null;
    case types.WIZARDS_INFO_FULLFILLED:
      if (typeof action.examResponsesWindowOpen === 'boolean') {
        return action.examResponsesWindowOpen;
      }
      return state;
    default:
      return state;
  }
};

const examTreatment = (state = 'optout', action) => {
  switch (action.type) {
    case types.WIZARDS_DISABLE:
      return 'optout';
    case types.WIZARDS_FLAGS_INIT:
      return action.examTreatment;
    default:
      return state;
  }
};

const modalMessage = (state = '', action) => {
  switch (action.type) {
    case types.WIZARDS_EXAM_CLOSE:
      return `modalCloseRequest${action.closeCount}`;
    default:
      return state;
  }
};

const modalClosedCount = (state = 0, action) => {
  switch (action.type) {
    case types.WIZARDS_EXAM_CLOSE:
      return ++state;
    default:
      return state;
  }
};

const wizardsReducer = combineReducers({
  rendering,
  video,
  showWizard,
  showWizardButtons,
  showWizardReminders,
  url,
  subjects,
  examResponsesWindowOpen,
  examTreatment,
  modalMessage,
  modalClosedCount,
});

export default wizardsReducer;
